import { Space, Tag } from "antd";
import React from "react";
import { ROUTER_PAGE } from "../../constants/router.const";
import { Link } from "react-router-dom";

export const TagVideoList = ({ tags = [], isKeepPage }) => {
  return (
    <Space wrap size={[0, 4]}>
      {tags.map((tag) => (
        <Link
          target={`${isKeepPage ? "" : "_blank"}`}
          onClick={(e) => e.stopPropagation()}
          key={tag}
          to={ROUTER_PAGE.VIDEO[0] + "?tag=" + `${tag}`}
        >
          {
            <Tag style={{}} color="blue">
              <span
                style={{
                  color: "#0080cb",
                }}
              >
                {tag}
              </span>
            </Tag>
          }
        </Link>
      ))}
    </Space>
  );
};
